module.exports = __webpack_public_path__ + "static/media/2.55feef4d.jpg";